<template>
  <div
    :class="[computedSize ? 'rt-loading-' + computedSize : '']"
    class="rt-loading"
  >
    <div
      v-show="visible"
      :class="[showMask ? 'rt-loading-mask' : 'rt-loading-hide-mask']"
    ></div>
    <transition
      name="rt-fade-ease-in-out"
      @after-leave="handleAfterLeave"
    >
      <div
        v-show="visible"
        class="rt-loading-spinner"
      >
        <span
          v-if="computedType === 1 || !computedType"
          class="rt-loading-dot"
        >
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span
          v-else
          class="rt-loading-circle"
        ></span>
        <p
          v-if="textColor"
          :class="[textColor ? 'rt-loading-text-' + textColor : '']"
          class="rt-loading-text"
        >
          {{ text }}
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import xpcConfig from '../../../config';
export default {
  data () {
    return {
      text: null,
      spinner: null,
      background: null,
      visible: false,
      type: {
        type: Number,
        default: 1
      },
      size: '',
      textColor: '',
      showMask: false
    };
  },
  computed: {
    computedType () {
      return this.type || xpcConfig.get('loading.type');
    },
    computedSize () {
      return this.size || xpcConfig.get('loading.size');
    }
  },
  methods: {
    handleAfterLeave () {
      this.$emit('after-leave');
    },
    setText (text) {
      this.text = text;
    },
    setSize (size) {
      this.size = size;
    },
    setTextColor (textColor) {
      this.textColor = textColor;
    },
    setType (type) {
      this.type = type;
    },
    setHiddenMask (hiddenMask) {
      this.hiddenMask = hiddenMask;
    }
  }
};
</script>



// WEBPACK FOOTER //
// loading.vue?cd65d2a6